module.exports = __webpack_public_path__ + "img/movie-walker.e5df3c73.png";